// extracted by mini-css-extract-plugin
export default {"range":"Title_range__BUXZZ","popover":"Title_popover__L4XN9"};